import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserNavigation } from 'navi'
import './index.css';
import App from './App';
import pages from './pages'

const main = async () => {
  let navigation = createBrowserNavigation({ pages })

  // Wait for the content to be ready
  await navigation.steady()

  // Render our app and pass in the navigation
  ReactDOM.render(
    <App navigation={ navigation } />,
    document.getElementById('root')
  );
}

// Start the app
main()
